import { useState } from "react";

const WA_URL = "https://wa.me/5561994176754?text=" + encodeURIComponent("Olá! Tenho interesse na análise de Visagismo IA e gostaria de tirar algumas dúvidas.");

export function WhatsAppFab() {
  const [hover, setHover] = useState(false);
  return (
    <a
      href={WA_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Fale conosco pelo WhatsApp"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="fixed z-[60] right-5 bottom-5 flex items-center gap-2 group"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <span
        className={`hidden md:block whitespace-nowrap rounded-full bg-[#0F0F10] text-[#F5F1E8] text-sm px-4 py-2 shadow-lg border border-[#C8A46A]/30 transition-all duration-300 ${hover ? "opacity-100 translate-x-0" : "opacity-0 translate-x-2 pointer-events-none"}`}
      >
        Fale conosco pelo WhatsApp
      </span>
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] shadow-[0_10px_30px_-6px_rgba(37,211,102,0.6)] transition-transform duration-300 group-hover:scale-105">
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
        <svg viewBox="0 0 32 32" className="w-8 h-8 relative" fill="#fff" aria-hidden="true">
          <path d="M16.004 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.257.59 4.46 1.71 6.4L3.2 28.8l6.57-1.72a12.74 12.74 0 0 0 6.23 1.59h.005c7.06 0 12.8-5.74 12.8-12.8s-5.74-12.8-12.8-12.8zm0 23.36h-.004a10.6 10.6 0 0 1-5.4-1.48l-.387-.23-4.02 1.05 1.073-3.92-.252-.402a10.56 10.56 0 0 1-1.62-5.64c0-5.86 4.77-10.63 10.63-10.63 2.84 0 5.51 1.106 7.52 3.115a10.56 10.56 0 0 1 3.11 7.52c0 5.86-4.77 10.62-10.63 10.62zm5.83-7.96c-.32-.16-1.89-.93-2.18-1.04-.29-.107-.5-.16-.71.16-.213.32-.82 1.04-1.005 1.253-.185.213-.37.24-.69.08-.32-.16-1.35-.498-2.57-1.586-.95-.847-1.59-1.893-1.777-2.213-.186-.32-.02-.493.14-.652.144-.143.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.71-1.713-.973-2.347-.257-.615-.518-.532-.71-.542l-.605-.01c-.213 0-.56.08-.853.4-.293.32-1.12 1.093-1.12 2.667 0 1.573 1.147 3.093 1.307 3.307.16.213 2.253 3.44 5.46 4.826.763.33 1.36.527 1.824.674.766.244 1.464.21 2.016.127.615-.092 1.89-.773 2.156-1.52.267-.747.267-1.387.187-1.52-.08-.133-.293-.213-.613-.373z" />
        </svg>
      </span>
    </a>
  );
}
